export const LIMITS = {
  QUESTION_ID: 40,
  OPTION_ID: 40,
  OPTIONS_PER_ANSWER: 50,
  FREE_TEXT: 10_000,
  ANSWERS: 50,
} as const;
